import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, DropdownButton, Col, Row, Badge, OverlayTrigger, Tooltip, ButtonGroup, ToastContainer, Spinner } from 'react-bootstrap';

import { EditionService } from '../../services/EditionService';
import { FactureService } from '../../services/FactureService';

import DynamicTable from '../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../components/pagination/Pagination';
import SideDetails from '../../components/side-details/SideDetails';
import FactureDetails from '../../components/side-details/facture/facture-details/FactureDetails';
//import FactureEdition from '../../components/side-details/facture/facture-edition/FactureEdition';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../components/families/Families';
import './Factures.scss';
import { PreferenceService } from '../../services/PreferenceService';
import ConfirmDialog from '../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../components/error-manager/ErrorManager";
import SendMailDialog from "../../components/send-mail-dialog/SendMailDialog";
import Brouillons from "../../components/brouillons/Brouillons";
import { GlobalContext } from "../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, granted, getFile, formattedDateInput } from '../../helper/Helper'
import TagsFilter from "../../components/tags-filter/TagsFilter";


const Factures = () => {

  const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

  let facturesParams = useRef({
    'start': 0,
    'limit': null,
    'search': null,
    'filters': {},
    'sort': null,
    'order': null
  });

  let openTab = useRef();

  const navigate = useNavigate();

  const [globalError, setGlobalError] = useState()
  const [searchParams, setSearchParams] = useSearchParams();
  const [factures, setFactures] = useState()
  const [isGetFacturesLoading, setIsGetFacturesLoading] = useState()
  const [isPDFLoading, setIsPDFLoading] = useState()
  const [sideWidth, setSideWidth] = useState()
  const [tableHeaders, setTableHeaders] = useState()
  const [checkedElementIdList, setCheckedElementIdList] = useState([])
  const [currentPagination, setCurrentPagination] = useState(1)
  const [isTableFilterVisible, setIsTableFilterVisible] = useState(false)
  const [confirmDialog, setConfirmDialog] = useState({ show: false, dialogInfos: null })
  const [currentFacture, setCurrentFacture] = useState()
  const [sendMailDialog, setSendMailDialog] = useState({})

  let searchRef = useRef(null);

  const [tableRowElementActions] = useState([
    { icon: "print", title: "Imprimer", action: "downloadPDF" },
    { icon: "email", title: "Envoyer par mail", action: "sendEmail" },
    { icon: "local_shipping", title: "Imprimer le bon de livraison", action: "downloadBonLivraisonPDF" }
  ])

  const [factureElementActions] = useState([
    { icon: "print", title: "Imprimer", action: "downloadPDF" },
    { icon: "email", title: "Envoyer par mail", action: "sendEmail" },
    { icon: "local_shipping", title: "Imprimer le bon de livraison", action: "downloadBonLivraisonPDF" }
  ])

  useEffect(() => {
    if (grants) {
      granted(grants, "factures.edit") && tableRowElementActions.push({ icon: "edit", title: "Modifier la facture (crée un brouillon)", action: "editFacture", disableKeyValues: { 'type': ['avoir'] } })
      granted(grants, "factures.edit") && factureElementActions.push({ icon: "edit", title: "Modifier la facture (crée un brouillon)", action: "editFacture", disableKeyValues: { 'type': ['avoir'] } })
      granted(grants, "factures.edit") && tableRowElementActions.push({ icon: "file_copy", title: "Dupliquer (crée un brouillon)", action: "duplicateFacture", disableKeyValues: { 'type': ['avoir'] } })
      granted(grants, "factures.edit") && factureElementActions.push({ icon: "file_copy", title: "Dupliquer (crée un brouillon)", action: "duplicateFacture", disableKeyValues: { 'type': ['avoir'] } })

      granted(grants, "reglements.edit") && tableRowElementActions.push({ icon: "credit_card", title: "Ajouter un règlement", action: "addReglement" })

      granted(grants, "proformas.edit") && tableRowElementActions.push({ icon: "description", title: "Convertir en brouillon de proforma", action: "convertToProforma", disableKeyValues: { 'type': ['avoir'] } })
      granted(grants, "proformas.edit") && factureElementActions.push({ icon: "description", title: "Convertir en brouillon de proforma", action: "convertToProforma", disableKeyValues: { 'type': ['avoir'] } })
      granted(grants, "proformas.edit") && tableRowElementActions.push({ icon: "description", title: "Convertir en brouillon d'abonnement", action: "convertToAbonnement", disableKeyValues: { 'type': ['avoir'] } })
      granted(grants, "proformas.edit") && factureElementActions.push({ icon: "description", title: "Convertir en brouillon d'abonnement", action: "convertToAbonnement", disableKeyValues: { 'type': ['avoir'] } })

      granted(grants, "factures.remove") && tableRowElementActions.push({ icon: "delete_forever", title: "Annuler la facture (crée un avoir)", action: "removeFactureDialog" })
      granted(grants, "factures.remove") && factureElementActions.push({ icon: "delete_forever", title: "Annuler la facture (crée un avoir)", action: "removeFactureDialog" })
    }
  }, [grants]);

  useEffect(() => {
    if (globalContextLoaded) {
      searchParams.get('factureId') && getFacture(searchParams.get('factureId'))
      setPreferences()
      getFactures()

      // Si un brouillon est en cours d'édition on redirige.
      if (!searchParams.get('factureId') && preferences.factures.currentDraft) {
        navigate(`/${folderDetails?.dossier?._id}/factures/brouillon?brouillonId=${preferences.factures.currentDraft}&from=factures`)
      }

    }
  }, [globalContextLoaded]);

  function setPreferences() {
    setTableHeaders(formatTableHeadersFromPrefs(preferences.factures['tableHeaders'], parametres.factures['fieldsLabel']))
    facturesParams.current['sort'] = preferences.factures['tableSort']
    facturesParams.current['order'] = preferences.factures['tableOrder']
    facturesParams.current['limit'] = preferences.factures['tableCount'] || 5
    facturesParams.current['fields'] = Object.keys(preferences.factures['tableHeaders']).join(',')
  }

  function getDayTitle(place) {
    let dateRef = facturesParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value ? new Date(facturesParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value + "T00:00:00") : new Date()
    var newDate = new Date(dateRef.getTime())
    newDate.setDate(dateRef.getDate() + place);
    var days = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
    var dayName = days[newDate.getDay()];
    return `${dayName} ${newDate.getDate()}`
  }

  function getFacture(factureId) {
    if (granted(grants, "factures.consult")) {
      FactureService.getFacture(folderDetails?.dossier?._id, factureId).then(res => {
        if (res.status == 204) {
          setGlobalError({ statusText: "La facture demandée n'a pas été trouvée" })
        } else if (!res.data?.data) {
          setGlobalError({ statusText: res.statusText })
        } else {
          changeCurrentFacture(res.data.data)
        }
      }).catch(error => {
        setGlobalError(error)
      });
    }
  }

  function getFactures() {
    setCheckedElementIdList([])
    if (granted(grants, "factures.consult")) {
      setIsGetFacturesLoading(true)
      FactureService.getFactures(folderDetails?.dossier?._id, facturesParams.current).then(res => {
        setFactures(res.data.data)
        setIsGetFacturesLoading(false)
      }).catch(error => {
        setIsGetFacturesLoading(false)
        setGlobalError(error)
      });
    }
  }

  function getFacturesPDF(idList) {
    if (granted(grants, "factures.consult")) {
      !idList && setIsPDFLoading(true)
      let params = {
        'start': 0,
        'search': facturesParams.current.search,
        'sort': facturesParams.current.sort,
        'order': facturesParams.current.order,
        'filters': facturesParams.current.filters
      }

      if (idList) {
        params['factures'] = idList
      }

      EditionService.getListe(folderDetails?.dossier?._id, params, "factures", "pdf").then(res => {
        setIsPDFLoading(false)
        if (!res?.data) {
          setGlobalError({ statusText: res.statusText })
        } else {
          getFile(res)
        }
      }).catch(error => {
        setIsPDFLoading(false)
        setGlobalError(error)
      });
    }
  }

  function removeFactureList(factureIdList) {
    FactureService.removeFactures(folderDetails?.dossier?._id, factureIdList).then(res => {
      setConfirmDialog({ show: false });
      getFactures()
      changeCurrentFacture()
      setSideWidth()
      uncheckElementList(factureIdList)
    }).catch(err => {
      setConfirmDialog({
        ...confirmDialog,
        dialogInfos: { ...confirmDialog.dialogInfos, error: err }
      })
    });
  }

  function uncheckElementList(idList) {
    let checkedElementIdListCopy = [...checkedElementIdList];
    idList.map(id => {
      let index = checkedElementIdListCopy.indexOf(id)
      if (index >= 0) {
        checkedElementIdListCopy.splice(index, 1)
      }
    })
    setCheckedElementIdList(checkedElementIdListCopy)
  }

  function saveTableHeadersPrefs(e) {
    const newHeadersObject = {}
    e.forEach(object => {
      newHeadersObject[object['dataTarget']] = { position: object['position'], hidden: object['hidden'] }
    });
    updatePreference({ ["tableHeaders"]: newHeadersObject })
  }

  function updatePreference(prefs) {
    PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['factures']: prefs } }).then(res => {
      getPreferences()
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function changeCurrentFacture(facture) {
    openTab.current = null
    facture?._id ? setSearchParams({ factureId: facture._id }) : setSearchParams(searchParams.delete('factureId'))
    setCurrentFacture(facture)
  }

  function changeTableHeaders(e) {
    setTableHeaders(e)
    saveTableHeadersPrefs(e)
  }

  function changePagination(p) {
    setCurrentPagination(p)
    facturesParams.current['start'] = (facturesParams.current.limit * p) - facturesParams.current.limit
    getFactures()
  }

  function changeLimit(l) {
    facturesParams.current['limit'] = l
    updatePreference({ ["tableCount"]: l })
    changePagination(1)
  }

  let searchTimeOut;
  function changeSearchValue(value) {
    window.clearTimeout(searchTimeOut);
    searchTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      facturesParams.current['start'] = 0
      facturesParams.current['search'] = value ? value : ""
      searchRef.current.value = value ? value : ""
      getFactures()
    }, 1000);
  }

  let filtersTimeOut;
  function changeFilters(f) {
    window.clearTimeout(filtersTimeOut);
    filtersTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      facturesParams.current['start'] = 0
      facturesParams.current['filters'] = f ? f : {}
      getFactures()
    }, 1000);
  }

  function clearFilters() {
    setCurrentPagination(1)
    facturesParams.current['start'] = 0
    facturesParams.current['filters'] = {}
    getFactures()
    setIsTableFilterVisible(false)
  }

  function changeTagIdList(tagIdList) {
    let filtersCopy = { ...facturesParams?.current['filters'] }
    if (tagIdList.length > 0) {

      let tagArray = []
      tagIdList.map(tagId => {
        tagArray.push(tagId)
      })

      if (!filtersCopy[`filter[client.tags._id]`]) {
        filtersCopy[`filter[client.tags._id]`] = []
      }

      filtersCopy[`filter[client.tags._id]`] = [
        {
          "operation": "equal_to",
          "operator": "=",
          "value": tagArray.toString()
        }
      ]
      changeFilters(filtersCopy)
      setIsTableFilterVisible(true)
    } else {
      if (filtersCopy && filtersCopy[`filter[client.tags._id]`]) {
        delete filtersCopy[`filter[client.tags._id]`]
        changeFilters(filtersCopy)
      }
    }
  }

  function changeSortOrder(s, o) {
    facturesParams.current['sort'] = s
    facturesParams.current['order'] = o
    updatePreference({ ["tableSort"]: s, ["tableOrder"]: o })
    getFactures()
  }

  function onFactureSaved(factureId) {
    getFacture(factureId)
    getFactures()
  }

  function onTabChange() {
    getFactures()
  }

  function closeSide() {
    setCurrentFacture()
  }

  function openBrouillon(brouillonId, documentType) {
    navigate(`/${folderDetails?.dossier?._id}/${documentType}/brouillon?brouillonId=${brouillonId}&from=factures`)
  }

  function createNewDocument(documentType) {
    let newDocument = {
      "type": documentType
    }
    FactureService.postFacture(folderDetails?.dossier?._id, { factures: [newDocument] }).then(res => {
      for (var brouillonId in res.data.data.brouillons) {
        openBrouillon(brouillonId, "factures")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function addFilterDate(value) {
    let showDate = facturesParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value ? new Date(facturesParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value + 'T12:12:00') : new Date()
    if (value == "today") {
      showDate = new Date()
    }
    if (value == "next") {
      showDate.setDate(showDate.getDate() + 1)
    }
    if (value == "prev") {
      showDate.setDate(showDate.getDate() - 1)
    }
    setIsTableFilterVisible(true)
    if (facturesParams.current.filters) {
      facturesParams.current.filters['filter[date]'] = [{ "operation": "equal_to", "operator": "=", "value": formattedDateInput(showDate) }]
    } else {
      facturesParams.current.filters = { 'filter[date]': [{ "operation": "equal_to", "operator": "=", "value": formattedDateInput(showDate) }] }
    }
    let tableHeadersCopy = [...tableHeaders];
    tableHeadersCopy.find(t => t.dataTarget == "date").hidden = false
    setTableHeaders(tableHeadersCopy);
    setCurrentPagination(1)
    facturesParams.current['start'] = 0
    getFactures()
  }

  function removeFactureListDialog(factureIdList) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: `Supprimer ${factureIdList.length} facture(s) ?`,
        description: 'Voulez vous supprimer les éléments sélectionnés ?',
        actionName: 'Supprimer la sélection',
        btnVariant: 'danger',
        element: factureIdList,
        error: false,
        confirmAction: 'removeFactureList'
      }
    })
  }

  function removeFactureDialog(facture) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: facture.nom,
        description: 'Confirmer la création de l\'avoir qui annulera la facture ?',
        actionName: 'Confirmer',
        btnVariant: 'danger',
        element: [facture._id],
        error: false,
        confirmAction: 'removeFactureList'
      }
    })
  }

  function downloadPDF(facture) {
    EditionService.getFacture(folderDetails?.dossier?._id, facture._id, "pdf").then(res => {
      if (!res.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(async (error) => {
      if (
        error.request.responseType === 'blob' &&
        error.response.data instanceof Blob &&
        error.response.data.type &&
        error.response.data.type.toLowerCase().indexOf('json') != -1
      ) {
        setGlobalError({ response: JSON.parse(await error.response.data.text()) })
      } else {
        setGlobalError(error)
      }
    });
  }

  function downloadBonLivraisonPDF(facture) {
    EditionService.getBonLivraison(folderDetails?.dossier?._id, facture._id, "pdf").then(res => {
      if (!res.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(async (error) => {
      if (
        error.request.responseType === 'blob' &&
        error.response.data instanceof Blob &&
        error.response.data.type &&
        error.response.data.type.toLowerCase().indexOf('json') != -1
      ) {
        setGlobalError({ response: JSON.parse(await error.response.data.text()) })
      } else {
        setGlobalError(error)
      }
    });
  }

  function sendEmail(facture, source) {

    // Si envoie mail à partir d'une facture unique'
    if (facture) { 
      let params = {
        filter: {
          _id: "=" + facture._id
        }
      }

      setSendMailDialog({
        "clientIdList": [facture.client_id],
        "folderId": folderDetails?.dossier?._id,
        "editionUrl": "factures",
        "params": params,
        "totalElements": 1,
        "show": true
      })
      return
    }

    // Si envoie mail à partir des filtres
    if (source == "filters") { 
      let params = {
        filters: facturesParams.current.filters,
        search: facturesParams.current.search,
        filter: {}
      }

      if(factures?.total == 1) {
        params['filter']['_id'] = "=" + factures.factures[0]._id
      }

      setSendMailDialog({
        "clientIdList": factures?.total == 1 ? [factures.factures[0].client_id] : null,
        "folderId": folderDetails?.dossier?._id,
        "editionUrl": "factures",
        "params": params,
        "totalElements": factures?.total,
        "show": true
      })
      return
    }

    // Si envoie mail à partir des éléments sélectionnés
    if (source == "checked") { 
      let params = {
        filter: {
          _id: "=" + checkedElementIdList.join(',')
        }
      }

      let factureClientIdList = factures?.factures.filter(f => checkedElementIdList.includes(f._id)).map(f => f.client_id)

      setSendMailDialog({
        "clientIdList": [factureClientIdList],
        "folderId": folderDetails?.dossier?._id,
        "editionUrl": "factures",
        "params": params,
        "totalElements": checkedElementIdList.length,
        "show": true
      })
      return
    }

  }

  function downloadCheckedFactures() {

    let params = {}
    if (checkedElementIdList?.length > 0) {
      params["filter"] = {}
      params["filter"]["_id"] = "=" + checkedElementIdList.join(',')
    }

    EditionService.getFactures(folderDetails?.dossier?._id, params).then(res => {
      if (!res.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function addReglement(facture) {
    openTab.current = "reglements"
    facture?._id ? setSearchParams({ factureId: facture._id }) : setSearchParams(searchParams.delete('factureId'))
    setCurrentFacture(facture)
  }

  function editFacture(facture) {
    FactureService.updateFacture(folderDetails?.dossier?._id, facture._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "factures")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function duplicateFacture(facture) {
    FactureService.duplicateFacture(folderDetails?.dossier?._id, facture._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "factures")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function convertToProforma(facture) {
    FactureService.convertToProforma(folderDetails?.dossier?._id, facture._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "proformas")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function convertToAbonnement(facture) {
    FactureService.convertToAbonnement(folderDetails?.dossier?._id, facture._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "abonnements")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  return (
    <Container fluid id="Factures" className="py-4">

      <div className="pb-2 d-flex align-items-center justify-content-between">
        <h4 className="m-0">Factures</h4>
        <div>
          {/* Brouillons en cours */}
          <Brouillons brouillonTypes={["facture", "avoir"]} openBrouillon={b => openBrouillon(b, "factures")} />
          {granted(grants, "factures.edit") &&
            <Dropdown as={ButtonGroup} className="ms-2">
              <Button variant="primary" onClick={() => createNewDocument("facture")}>Créer une facture</Button>
              <Dropdown.Toggle split variant="primary" />
              <Dropdown.Menu>
                <Dropdown.Item as="button" onClick={() => createNewDocument("avoir")}>Créer un avoir</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          }
        </div>
      </div>

      <ErrorManager error={globalError} fixed="true" />

      <SendMailDialog clientIdList={sendMailDialog.clientIdList} folderId={sendMailDialog.folderId} editionUrl={sendMailDialog.editionUrl} params={sendMailDialog.params} totalElements={sendMailDialog.totalElements} show={sendMailDialog.show} setCloseModal={() => setSendMailDialog({ show: false })} />

      <ConfirmDialog
        show={confirmDialog.show}
        dialogInfos={confirmDialog.dialogInfos}
        setCancel={() => setConfirmDialog({ show: false })}
        setConfirm={(a, e) => eval(a)(e)}
      />

      <Row>
        <Col xs="12">
          {granted(grants, "factures.consult") ?
            <>
              <Row className="mb-4 gx-2">
                <Col sm="12" md="6" lg="auto" xl="3" className="mb-2 mb-lg-0">
                  <InputGroup className="w-auto">
                    <i className="material-icons input-icon text-gray-400">search</i>
                    <FormControl
                      className="input-icon-space rounded-start"
                      placeholder="Recherche globale"
                      type="text"
                      onChange={e => changeSearchValue(e.target.value)}
                      ref={searchRef}
                    />
                    {facturesParams.current['search'] &&
                      <Button onClick={() => changeSearchValue()} variant="gray-100" className="border border-start-0">
                        <i className="material-icons i-lg">clear</i>
                      </Button>
                    }
                  </InputGroup>
                </Col>
                <Col sm="12" md="auto" xl="auto" className="d-flex mb-2 mb-xl-0">
                  <InputGroup className="me-2 w-auto">
                    <TagsFilter btnClassName="rounded-end-0" btnTitle="Filtrer par tags client" documentType="clients" changeTagIdList={tagIdList => changeTagIdList(tagIdList)} parentFilters={facturesParams?.current['filters']} />
                    {Object.keys(facturesParams.current.filters).length == 0 &&
                      <OverlayTrigger placement="right" delay={{ show: 800 }} overlay={<Tooltip>Filtres de recherche</Tooltip>}>
                        <Button variant="secondary" onClick={() => setIsTableFilterVisible(!isTableFilterVisible)}>
                          <i className="material-icons i-lg">filter_alt</i>
                        </Button>
                      </OverlayTrigger>
                    }
                    {Object.keys(facturesParams.current.filters).length != 0 &&
                      <Button className="d-flex" variant="warning" onClick={() => clearFilters()}>
                        Suppr. les filtres
                        <i className="material-icons i-lg ms-2 d-inline-flex">clear</i>
                      </Button>
                    }
                  </InputGroup>
                  <ColManager tableHeaders={tableHeaders} changeTableHeaders={e => changeTableHeaders(e)} />
                </Col>
                <Col sm="12" md="auto" xl="auto" className="d-flex mb-2 mb-xl-0">
                  <ButtonGroup className="">
                    <Button variant="secondary" onClick={() => addFilterDate("prev")}>
                      {getDayTitle(-1)}
                      <i className="material-icons float-start me-1">
                        arrow_back_ios_new
                      </i>
                    </Button>
                    <Button onClick={() => addFilterDate("today")} variant={facturesParams.current?.filters && facturesParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value == formattedDateInput(new Date()) ? "primary-200" : "secondary"} >Factures du jour</Button>
                    <Button variant="secondary" onClick={() => addFilterDate("next")}>
                      {getDayTitle(1)}
                      <i className="material-icons float-end ms-1">
                        arrow_forward_ios
                      </i>
                    </Button>
                  </ButtonGroup>
                </Col>
                <Col sm="12" md="auto" xl="auto" className="">

                  {factures?.total > 0 &&
                    <Dropdown className="d-inline-block me-2">
                      <Dropdown.Toggle variant="secondary" id="dropdown-selectionnes">
                        {factures?.total} Résultat{factures?.total > 1 && <span>s</span>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => getFacturesPDF()}>Imprimer la liste</Dropdown.Item>
                        {/* <Dropdown.Item onClick={() => getFacturesPDF()}>Imprimer les factures</Dropdown.Item> */}
                        <Dropdown.Item onClick={() => sendEmail(null, "filters")}>Envoyer les factures par mail</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  }

                  {checkedElementIdList?.length > 0 &&
                    <Dropdown className="d-inline-block me-2">
                      <Dropdown.Toggle variant="dark" id="dropdown-selectionnes">
                        {checkedElementIdList.length} Sélectionné{checkedElementIdList?.length > 1 && <span>s</span>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => getFacturesPDF(checkedElementIdList)}>Imprimer la liste</Dropdown.Item>
                        <Dropdown.Item onClick={() => downloadCheckedFactures()}>Imprimer les factures</Dropdown.Item>
                        <Dropdown.Item onClick={() => sendEmail(null, "checked")}>Envoyer les factures par mail</Dropdown.Item>
                        {granted(grants, "factures.remove") &&
                          <>
                            <Dropdown.Divider />
                            <Dropdown.Item className="text-danger" onClick={() => removeFactureListDialog(checkedElementIdList)}>Supprimer</Dropdown.Item>
                          </>
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  }
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs="12">
                  <div className="bg-white rounded border">
                    <DynamicTable
                      isDataLoading={isGetFacturesLoading}
                      elementActions={tableRowElementActions}
                      setElementAction={(a, e) => eval(a)(e)}
                      sideWidth={sideWidth}
                      tableHeaders={tableHeaders}
                      tableDataList={factures?.factures}
                      currentElement={currentFacture}
                      changeCurrentElement={e => changeCurrentFacture(e)}
                      checkedElementIdList={checkedElementIdList}
                      setCheckedElementIdList={e => setCheckedElementIdList(e)}
                      changeFilters={f => changeFilters(f)}
                      isTableFilterVisible={isTableFilterVisible}
                      changeSortOrder={(s, o) => changeSortOrder(s, o)}
                      params={facturesParams.current}
                    />
                    <Pagination className="m-3" itemsLength={factures?.total} elementsPerPage={facturesParams.current.limit} currentPagination={currentPagination} changePagination={p => changePagination(p)} showChangeLimit showDefinePage changeLimit={l => changeLimit(l)} />
                  </div>
                </Col>
              </Row>
            </>
            :
            <Row>
              <Col>
                <em className="py-1 px-2 bg-gray-100 rounded mt-2">- Vous n'avez pas les droits d'accès à cette ressource -</em>
              </Col>
            </Row>
          }

          {granted(grants, "factures.consult") && currentFacture &&
            <SideDetails
              currentElement={{ id: currentFacture?._id, label: new Date(currentFacture?.date).toLocaleString(), title: currentFacture?.client_nom }}
              changeCurrentElement={e => changeCurrentFacture(e)}
              setSideClose={closeSide}
              setSideWidth={e => setSideWidth(e)}
              detailsComponent={
                <FactureDetails openTab={openTab.current} folderId={folderDetails?.dossier?._id} factureId={currentFacture._id} elementActions={factureElementActions} setElementAction={(a, e) => eval(a)(e)} onTabChange={() => onTabChange()} />
              }
            />
          }
        </Col>
      </Row>

    </Container>


  );
}

export default Factures;